import React, { Component } from 'react';

export default class About extends Component {
    render() {
        return (<div>
            <h5>About CAV</h5>
            <p>
                Council Arboriculture Victoria Inc. (CAV) is an association of arborists, tree managers and related professions working in local government in Victoria. CAV supports its members to pursue best practice arboriculture and advocates on arboricultural matters across industry and government sectors. <a href="https://www.councilarboriculturevictoria.com.au/" target="blank">Find out more.</a>
            </p>
        </div>
        );
    }
}